import { createContext, useContext } from 'react';

/** Inside the landing layout the brand already sits in the top bar: the card skips its own. */
export const AuthChromeContext = createContext({ showLogo: true });

export const useAuthChrome = () => useContext(AuthChromeContext);
